import axios from 'axios'
import type { User } from '../types'

const API_URL = import.meta.env.VITE_API_URL || '/api'

export const authService = {
  getGoogleAuthUrl: () => {
    return `${API_URL}/auth/google`
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await axios.get(`${API_URL}/auth/me`, {
      withCredentials: true,
    })
    return response.data
  },

  logout: async (): Promise<void> => {
    await axios.post(
      `${API_URL}/auth/logout`,
      {},
      {
        withCredentials: true,
      }
    )
  },
}
